import tPModel from '../../models/training-program';
import ReducerUtilities from '../../../shared/store/reducer-utilities';
import trainingProgramsCommitTypes from './commit-types';

const INITIAL_TPS_STATE = {
  isEditingTP: false,
  isLoading: [],
  list: null,
  selectedTPGuid: false,
  isAddingNewPhase: false
};

function tPsReducers(state = INITIAL_TPS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case trainingProgramsCommitTypes.PUSH_TP:
      return {
        ...state,
        list: [tPModel(action.trainingProgram), ...state.list],
      };
    case trainingProgramsCommitTypes.PUSH_TPS:
      return {
        ...state,
        list: [...action.list.map(item => tPModel(item))],
      };
    case trainingProgramsCommitTypes.REPLACE_TP:
      return {
        ...state,
        list: ReducerUtilities.replaceModelInList(tPModel(action.trainingProgram), state.list),
      };
    case trainingProgramsCommitTypes.REPLACE_TPS:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelsInList(
            action.list.map(item => tPModel(item)),
            state.list,
          ),
        ],
      };
    case trainingProgramsCommitTypes.RESET_TPS_STATE:
      return { ...INITIAL_TPS_STATE };
    case trainingProgramsCommitTypes.SET_IS_EDITING_TP:
      return {
        ...state,
        isEditingTP: action.isEditingTP,
      };
    case trainingProgramsCommitTypes.SET_SELECTED_TP_GUID:
      return {
        ...state,
        selectedTPGuid: action.selectedTPGuid,
      };
    case trainingProgramsCommitTypes.SET_TP_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case trainingProgramsCommitTypes.SET_IS_ADDING_NEW_PHASE:
      return {
        ...state,
        isAddingNewPhase: action.isAddingNewPhase
      };
    default:
      return state;
  }
}

export default tPsReducers;
